import type { ConditionRangeValue } from '../conditions.types';
import type { BoundUnits } from './formatBound';
import { formatBound } from './formatBound';

/**
 * A selected range as a tag reads it, ex `1g ($5-$17.50)`.
 *
 * An open bound is a legitimate selection rather than a half-finished one, so
 * each combination gets its own phrasing — and a row selected at any value is
 * just its own label.
 */
export const toRangeLabel = (
  { max, min }: ConditionRangeValue,
  units?: BoundUnits
): string => {
  if (min !== undefined && max !== undefined) {
    return `${formatBound(min, units)}-${formatBound(max, units)}`;
  }

  if (min !== undefined) {
    return `${formatBound(min, units)}+`;
  }

  if (max !== undefined) {
    return `up to ${formatBound(max, units)}`;
  }

  return '';
};
